import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { BehaviorSubject, Subscription } from "rxjs";
import { map, take } from "rxjs/operators";
import { UDXOrderQRService } from "src/app/udxb2b/services/udx-order-qr.service";
import { USJB2BPortalConfig } from "src/app/udxb2b/shared/constant/storefront-config";
import { BaseSiteService, GlobalMessageService, GlobalMessageType, OccEndpointsService, TranslationService, UserIdService, TranslatePipe } from "@spartacus/core";
import { UDXAppConstants } from "src/app/udxb2b/utilities/constants/udx-app.constants";
import { ProgressSpinnerDialogComponent } from "src/app/udxb2b/utilities/spinner/progress-spinner-dialog.component";
import { CheckboxState, OrderQRKeyValue, UDXOrderQRData, UDXOrderQRDataSubentry } from "./model/udx-order-qr.model";
import { SpinnerComponent, PaginationComponent } from "@spartacus/storefront";
import { NgSelectComponent, NgOptionComponent } from "@ng-select/ng-select";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { NgClass, AsyncPipe } from "@angular/common";
import { DayjsFormatPipe } from "../../../utilities/date/dayjs-format.pipe";

@Component({
    selector: 'udx-cx-order-qr',
    templateUrl: './udx-order-qr.component.html',
    styleUrls: ['./udx-order-qr.component.scss'],
    imports: [SpinnerComponent, RouterLink, NgSelectComponent, ReactiveFormsModule, FormsModule, NgOptionComponent, PaginationComponent, NgClass, AsyncPipe, TranslatePipe, DayjsFormatPipe]
})
export class UdxOrderQRComponent implements OnInit, OnDestroy {
  constructor(
    private _orderQRService: UDXOrderQRService,
    protected router: Router,
    protected activatedRoute: ActivatedRoute,
    protected globalMessage: GlobalMessageService,
    protected userIdService: UserIdService,
    public dialog: MatDialog,
    protected globalMessageService: GlobalMessageService,
    protected _occEndpoints: OccEndpointsService,
    protected _baseSiteService: BaseSiteService,
    protected translationService: TranslationService,
  ){}
  protected GLOBAL_MESSAGE_TIMEOUT = 10000;
  @Input() shouldPickOrderIDFromQueryParameter: boolean = true;
  protected subentriesData?:UDXOrderQRData;

  apiLoading$ = new BehaviorSubject(false);
  selectedTicketCodes: string[] = [];
  selectedOrderNumber = '';
  url: string='';
  currentBaseSite: string = '';
  ush = false;
  text = '';
  usjfeature = false;
  private subscription = new Subscription();

  ngOnInit(): void {
    this.fetchResults();
  }

  pageSize = UDXAppConstants.PREFERRED_PAGE_SIZE_TICKETS;
  fetchResults(pageNumber = '0', ticketTypeSelectedOption?:string, qrDownloadedSelectedOption?:string, sortSelectedOption?:string) {
    let orderNumber = (this.shouldPickOrderIDFromQueryParameter ? this.activatedRoute.snapshot.queryParamMap?.get('orderNumber') : this.router.url.split('?')[0].split('/')?.pop());
    this.selectedOrderNumber=orderNumber!;
    if (orderNumber) {
      this.apiLoading$.next(true);
      let userId$ = this.userIdService.takeUserId();
      userId$.pipe(
        take(1),
        map((res) => {
          this._orderQRService.fetchTicketDetails(
            orderNumber!,
            res,
            this.pageSize.toString(),
            pageNumber,
            sortSelectedOption,
            ticketTypeSelectedOption,
            qrDownloadedSelectedOption
          ).subscribe(
          (response: UDXOrderQRData) => {
            this.apiLoading$.next(false);
            this.subentriesData = response;
            // this.setCheckboxStateToAllSubentries(CheckboxState.eUncheckedState);  Across pages the selection needs to be retained
            this.initialiseFilterAndSortSelection();
            this.validateMasterCheckboxState();
          }, (error) => {
            this.apiLoading$.next(false);
            var errMsg = null;
            if (error.error.errors) {
              errMsg = error.error.errors[0].message;
            }
            this.globalMessage.add(errMsg, GlobalMessageType.MSG_TYPE_ERROR, this.GLOBAL_MESSAGE_TIMEOUT);
          })
        }),
      ).subscribe();
    } else {
      let transObject = {
        key: 'orderQRCommon.orderNumberNotFound'
      }
      this.globalMessage.add(transObject, GlobalMessageType.MSG_TYPE_ERROR, this.GLOBAL_MESSAGE_TIMEOUT);
    }
  }

  pageChange(pageNumber: number) {
    this.fetchResults(pageNumber.toString(), this.ticketTypeSelectedOptionForAPI(), this.qrDownloadedSelectedOptionForAPI());
  }

  // Filters and Sort - START
  protected ticketTypeSelectedOption?: string;
  ticketTypeSelectedOptionForAPI() {
    // Raj: As per Jun the option "All" needs to be excluded while sending the request
    return (("ALL"===this.ticketTypeSelectedOption) ? undefined : this.ticketTypeSelectedOption)
  }
  protected qrDownloadedSelectedOption?: string;
  qrDownloadedSelectedOptionForAPI() {
    // Raj: As per Jun the option "All" needs to be excluded while sending the request
    return (("ALL"===this.qrDownloadedSelectedOption) ? undefined : this.qrDownloadedSelectedOption)
  }
  protected sortSelectedOption?: string;
  selectTicketType(event: any) {
    // Raj: As per Jun the option "All" needs to be excluded while sending the request
    let ticketTypeFilterSelection = ("ALL"!=event) ? event : null;
    this.fetchResults(this.subentriesData?.pagination?.currentPage?.toString(), ticketTypeFilterSelection, this.qrDownloadedSelectedOptionForAPI(), this.sortSelectedOption);
  }
  selectQRDownloaded(event: any) {
    // Raj: As per Jun the option "All" needs to be excluded while sending the request
    let qrDownloadFilterSelection =  ("ALL" != event)? event : null;
    this.fetchResults(this.subentriesData?.pagination?.currentPage?.toString(), this.ticketTypeSelectedOptionForAPI(), qrDownloadFilterSelection, this.sortSelectedOption);
  }
  selectSortOption(event: any) {
    this.fetchResults(this.subentriesData?.pagination?.currentPage?.toString(), this.ticketTypeSelectedOptionForAPI(), this.qrDownloadedSelectedOptionForAPI(), event);
  }
  initialiseFilterAndSortSelection() {
    let selectedTicketType: OrderQRKeyValue[] | undefined = this.subentriesData?.ticketType?.filter((aTicketType) => (aTicketType.selected === true))
    if (selectedTicketType?.length) {
      this.ticketTypeSelectedOption = selectedTicketType[0].key;
    }
    let selectedQRDownloadedOption: OrderQRKeyValue[] | undefined = this.subentriesData?.qrCodeDownloadedStatus?.filter((qrOption) => (qrOption.selected === true))
    if (selectedQRDownloadedOption?.length) {
      this.qrDownloadedSelectedOption = selectedQRDownloadedOption[0].key;
    }
  }
  // Filters and Sort - END

  // Checkbox selection logic - START
  returnQualifiedSubentriesForCurrentPage(): UDXOrderQRDataSubentry[] {
    var subEntriesToConsiderForSelection: UDXOrderQRDataSubentry[] = [];
    if (this.subentriesData?.subEntries) {
      subEntriesToConsiderForSelection = this.subentriesData!.subEntries; // Filter out disabled state subentries here later if requried
    }
    return subEntriesToConsiderForSelection;
  }
  setCheckboxStateToAllSubentries(state: CheckboxState) {
    if (this.returnQualifiedSubentriesForCurrentPage()) {
      if (state === CheckboxState.eCheckedState) {
        const codesToAdd = this.returnQualifiedSubentriesForCurrentPage()
          .map(subEntry => subEntry.ticketCode!)
          .filter(code => !this.selectedTicketCodes.includes(code));
        this.selectedTicketCodes.push(...codesToAdd);
      } else {
        const codesToRemove = this.returnQualifiedSubentriesForCurrentPage().map(subEntry => subEntry.ticketCode!);
        this.selectedTicketCodes = this.selectedTicketCodes.filter(code => !codesToRemove.includes(code));
      }
    }
    this.validateMasterCheckboxState();
  }
  protected masterCheckboxState: CheckboxState = CheckboxState.eNoState;
  masterCheckboxSelectionToggle(event: any) {
    if (event.target.checked) {
      this.setCheckboxStateToAllSubentries(CheckboxState.eCheckedState);
    } else {
      this.setCheckboxStateToAllSubentries(CheckboxState.eUncheckedState);
    }
    this.validateMasterCheckboxState();
  }
  subentrySelected(event: any, subentry: UDXOrderQRDataSubentry, ticketCode: string) {
    if (event.target.checked) {
      this.selectedTicketCodes.push(ticketCode)
    } else {
      this.selectedTicketCodes = this.selectedTicketCodes.filter(code => code !== ticketCode);
    }
    this.validateMasterCheckboxState();
  }
  validateMasterCheckboxState() {
    this.masterCheckboxState = CheckboxState.eNoState;
    if (this.subentriesData?.subEntries) {
      let subEntriesToConsiderForSelectionFromCurrentPage = this.returnQualifiedSubentriesForCurrentPage();
      let selectedSubentriesFromCurrentPage = this.selectedTicketCodes.filter(code => {
        // If the selected code by user is present in subEntriesToConsiderForSelection only then return true
        return subEntriesToConsiderForSelectionFromCurrentPage.some(subEntry => subEntry.ticketCode === code);
      })
      if (selectedSubentriesFromCurrentPage.length === 0) {
        this.masterCheckboxState = CheckboxState.eUncheckedState;
      } else if (selectedSubentriesFromCurrentPage.length === subEntriesToConsiderForSelectionFromCurrentPage.length) {
        this.masterCheckboxState = CheckboxState.eCheckedState;
      } else {
        this.masterCheckboxState = CheckboxState.eCheckedState | CheckboxState.eUncheckedState; // Indeterminate state
      }
    }
  }
  isSubentrySelected(subEntry: UDXOrderQRDataSubentry) {
    var theSubEntrySelected = false;
    theSubEntrySelected = this.selectedTicketCodes.includes(subEntry.ticketCode!);
    return theSubEntrySelected;
  }
  isMastercheckboxInIndeterminateState() {
    let finalResult = ((this.masterCheckboxState === (CheckboxState.eCheckedState | CheckboxState.eUncheckedState)) ? true : false);
    return finalResult;
  }
  isMastercheckboxInCheckedState() {
    let finalResult = ((this.masterCheckboxState & CheckboxState.eCheckedState) && ((this.masterCheckboxState & CheckboxState.eUncheckedState)===0));
    // All subentries in checked state
    return finalResult;
  }
  // Checkbox selection logic - END

  shouldEnableDownloadSelectedQRs() {
    var buttonEnabled = false;
    buttonEnabled = (this.selectedTicketCodes.length > 0);
    return buttonEnabled;
  }
  generateQRSuccessful() {
    this.translationService.translate('orderQRCommon.downloadQRFilesGeneratedSuccessfully').subscribe((generatedSuccessfully: string) => {
      this.globalMessageService.add(
        generatedSuccessfully,
        GlobalMessageType.MSG_TYPE_CONFIRMATION
      );
    });
    // Raj - Retaining this old code to fetch results again after download, probably to refresh the list of tickets
    this.fetchResults(this.subentriesData?.pagination?.currentPage?.toString(), this.ticketTypeSelectedOptionForAPI(), this.qrDownloadedSelectedOptionForAPI());
  }
  downloadSelectedQRs() {
    let dialogRef: MatDialogRef<ProgressSpinnerDialogComponent> = this.dialog.open(ProgressSpinnerDialogComponent, {
      panelClass: 'transparent',
      disableClose: true,
    });
    this.subscription.add(
    this._orderQRService.triggerDownloadForSelectedQR(this.selectedTicketCodes,'SELECTED', this.selectedOrderNumber).subscribe((response: any) => {
      dialogRef.close();
      this.generateQRSuccessful();
    },
    (error: any) => {
      dialogRef.close();
      this.globalMessageService.add(
        error.error.errors ? error.error.errors[0].message : error.message,
        GlobalMessageType.MSG_TYPE_ERROR
      );
      this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_CONFIRMATION);
    })
  );
  }
  downloadAllQRs() {
    let dialogRef: MatDialogRef<ProgressSpinnerDialogComponent> = this.dialog.open(ProgressSpinnerDialogComponent, {
      panelClass: 'transparent',
      disableClose: true,
    });
  this.subscription.add(
   this._orderQRService.triggerDownloadForAllQR([],'ALL',this.selectedOrderNumber).subscribe((response: any) => {
    dialogRef.close();
    this.generateQRSuccessful();
  },
  (error: any) => {
    dialogRef.close();
    this.globalMessageService.add(
      error.error.errors ? error.error.errors[0].message : error.message,
      GlobalMessageType.MSG_TYPE_ERROR
    );
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_CONFIRMATION);
  })
 );
  }
  downloadFile(): void {
  const fileUrl = this.subentriesData?.qrPdfZipUrl ? this.subentriesData.qrPdfZipUrl : '';

  const anchor = document.createElement('a');
  anchor.href = fileUrl;
  anchor.target = '_blank';
  anchor.download = ''; // You can optionally set a filename here
  anchor.click();
}

  getBaseAPIURL(){
    return this._occEndpoints.getBaseUrl({
      baseSite: false,
      baseUrl: true,
      prefix: false,
    });
  }
   //Function to get the base storefront and the currency - Mehul
   getCurrentStoreBaseSite() {
    this._baseSiteService.getActive().pipe(take(1)).subscribe((currentSite) => {
      this.currentBaseSite = currentSite;
      USJB2BPortalConfig.filter((config) => config.baseSiteId === this.currentBaseSite).map((config) => {
        this.usjfeature = config.active;
      });
      switch (currentSite) {
        case 'b2bportal':
          this.ush  = false;
          this.text = 'QR(s)'
          break;
        default:
          this.ush = true;
          this.text = 'Ticket(s)'

          break;
      }
    });

   }

  pdfDownloadDisabled(): boolean | null{
    // Raj: Wrapping inside function just to negate results for testing!
    // return false;
    return (this.subentriesData?.pdfDownloadDisabled ?? null);
  }
  pdfDownloadExpired(): boolean {
    // Raj: Wrapping inside function just to negate results for testing!
    // return false;
    return (this.subentriesData?.pdfDownloadExpired ?? false);
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
   }
  downloadFileLinkExists(): boolean {
    return this.subentriesData?.qrPdfZipUrl ? true : false;
  }
}
